(function ($) {
    /**
     * Klick auf die Vergleichs-Checkbox
     */
    $(document).on('change', '.compare-checkbox-wrapper input', function () {
        if ($(this).prop('checked')) {
            //$('#compare-list').removeClass('closed');
            $(this).parent('.compare-checkbox-wrapper').addClass('checked');
        } else {
            $(this).parent('.compare-checkbox-wrapper').removeClass('checked');
        }
        refreshCompareList();
    });

    /**
     * Init Wrapper-Status
     */
    $('.compare-checkbox-wrapper input').each(function () {
        if ($(this).prop('checked')) {
            $(this).parent('.compare-checkbox-wrapper').addClass('checked');
        } else {
            $(this).parent('.compare-checkbox-wrapper').removeClass('checked');
        }
    });

    /**
     * Klick auf den Tarif-entfernen-Button
     */
    $(document).on('click', 'button.remove-tariff', function () {
        var tariffId = $(this).data('id');
        var $compareCheckbox = $('.compare-checkbox-wrapper input[value=' + tariffId + ']');
        $compareCheckbox.prop('checked', false);
        $compareCheckbox.parent('.compare-checkbox-wrapper').removeClass('checked');
        refreshCompareList();
    });

    /**
     * Klick auf den Schließen-Button
     */
    $(document).on('click', '#compare-list button.close, #compare-list figure.placeholder', function () {
        $('#compare-list').addClass('closed');
    });

    /**
     * Maximal 3 Tarife dürfen verglichen werden
     */
    $(document).on('click', '.compare input', function() {
        var countChecked = $('.compare input:checked').length;

        if (countChecked > 3) {
            //$('#compare-list').removeClass('closed');
            alert('Sie können maximal 3 Tarife zum Vergleichen anwählen');
            return false;
        }

        return true;
    });

    /**
     * Mindestens 2 Tarife müssen zum Vergleich ausgewählt werden
     */
    $(document).on('click', '#compare-list button[type=submit]', function() {
        var countChecked = $('.compare input:checked').length;

        // Wenn weniger als 2 Checkboxen ausgewählt sind, dann
        // sollen automatisch die ersten drei ausgewählt werden
        if (countChecked < 2) {
            alert('Markieren Sie bitte noch mindestens einen Tarif.');
            return false;
        }

        return true;
    });

    var getTariffs = function () {
        var tariffIds = [];
        $('.compare-checkbox-wrapper input:checked').each(function () {
            tariffIds.push($(this).val());
        });
        return tariffIds;
    };

    var refreshCompareList = function () {
        var tariffs = getTariffs();

        var $compareList = $('#compare-list');

        if (!tariffs.length) {
            $compareList.remove();
            return;
        }

        var $refreshedComapreList = $(renderSelectedTariffs(tariffs));

        if ($compareList.length) {
            $compareList.find('.content').replaceWith($refreshedComapreList.find('.content'));
        } else {
            $('body').append($refreshedComapreList);
        }
    };

    var renderSelectedTariffs = function (tariffs) {
        var markup = '<div id="compare-list" class="closed">';
        markup += '<button class="close">Schließen</button>';
        markup += '<div class="content">';

        markup += '<button type="submit" form="form-compare">Tarife vergleichen</button>';

        markup += '<ul>';

        var index;
        for (index = 0; index < 3; ++index) {
            markup += renderTariff(tariffs[index]);
        }

        markup += '</ul>';

        markup += '</div>';
        markup += '</div>';

        return markup;
    };

    var renderTariff = function (tariffId) {
        var $li = $('input[value=' + tariffId + ']').parents('li');

        if (!$li.length) {
            return '<li><figure class="placeholder"></figure></li>';
        }

        var title = $li.find('h2.title').html();
        var image = '';
        if ($li.find('.company img').length) {
            image = $li.find('.company img')[0].outerHTML;
        }

        var markup = '<li class="has-tariff">';
        markup += '<figure>' + image + '</figure>';
        markup += '<span class="tariff-title">' + title + '</span>';
        markup += '<button class="remove-tariff" title="Tarif entfernen" data-id="' + tariffId + '">';
        markup += '<span class="icon"></span>';
        markup += '</button>';
        markup += '</li>';
        return markup;
    };

    refreshCompareList();
})(jQuery);
